import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class AutomationAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/automation', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/automation/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (dist, success, failure) => {
    fetch(Config.app.link + 'api/automation', new Header('POST', dist))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/automation/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default AutomationAPI;